import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Radio, Radar, Box, Satellite, Zap, Shield, Brain, Clock, MessageSquare, Activity, LogOut, Menu, X, Play, Crosshair, ShieldAlert, Target, ShieldCheck, Sparkles, Server } from 'lucide-react';

export default function Layout({ children, onLogout }) {
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(true);

  const navItems = [
    { path: '/', icon: Radio, label: 'Dashboard' },
    { path: '/3d-view', icon: Box, label: '3D View' },
    { path: '/simulation', icon: Play, label: 'Simulation' },
    { path: '/tracking', icon: Radar, label: 'Tracking' },
    { path: '/fusion', icon: Zap, label: 'Fusion' },
    { path: '/sensors', icon: Satellite, label: 'Sensors' },
    { path: '/monitoring', icon: Activity, label: 'Monitor' },
    { path: '/behavior', icon: Brain, label: 'Behavior' },
    { path: '/countermeasures', icon: Shield, label: 'C-Measures' },
    { path: '/intelligence', icon: Brain, label: 'Intel' },
    { path: '/timeline', icon: Clock, label: 'Timeline' },
    { path: '/comms', icon: MessageSquare, label: 'Comms' },
    { path: '/classification', icon: Crosshair, label: 'Classify' },
    { path: '/mitigation', icon: ShieldAlert, label: 'Mitigate' },
    { path: '/auto-engage', icon: Activity, label: 'Auto Engage' },
    { path: '/live', icon: Radio, label: 'Live Mode' },
    { path: '/engagement-console', icon: Crosshair, label: 'Engage' },
    { path: '/readiness', icon: ShieldCheck, label: 'Readiness' },
    { path: '/saturation', icon: Sparkles, label: 'Saturation' },
    { path: '/system', icon: Server, label: 'System' },
    { path: '/kill-chain', icon: Target, label: 'Kill Chain' },
    { path: '/drill', icon: Zap, label: 'Drill' }
  ];

  return (
    <div className="flex h-screen bg-zinc-950 text-zinc-100">
      <aside
        className={`${
          sidebarOpen ? 'w-64' : 'w-20'
        } bg-zinc-900/50 border-r border-zinc-800 flex flex-col transition-all duration-300`}
        data-testid="sidebar"
      >
        <div className="h-16 flex items-center justify-between px-4 border-b border-zinc-800">
          {sidebarOpen && (
            <h1 className="text-xl font-bold tracking-tight uppercase text-sky-500">
              BRAHM KAVACH<sup className="text-[10px] ml-0.5">TM</sup>
            </h1>
          )}
          <button
            onClick={() => setSidebarOpen(!sidebarOpen)}
            className="p-2 hover:bg-zinc-800 rounded-sm transition-colors"
            data-testid="sidebar-toggle"
          >
            {sidebarOpen ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>

        <nav className="flex-1 py-4" data-testid="nav-menu">
          {navItems.map((item) => {
            const Icon = item.icon;
            const isActive = location.pathname === item.path;
            return (
              <Link
                key={item.path}
                to={item.path}
                className={`flex items-center gap-3 px-4 py-3 hover:bg-zinc-800 border-l-2 transition-colors ${
                  isActive
                    ? 'border-sky-500 bg-zinc-800 text-sky-500'
                    : 'border-transparent text-zinc-400'
                }`}
                data-testid={`nav-${item.label.toLowerCase()}`}
              >
                <Icon size={20} />
                {sidebarOpen && (
                  <span className="text-sm font-medium uppercase tracking-wider">
                    {item.label}
                  </span>
                )}
              </Link>
            );
          })}
        </nav>

        <div className="p-4 border-t border-zinc-800">
          <button
            onClick={onLogout}
            className="flex items-center gap-3 px-4 py-3 w-full hover:bg-zinc-800 rounded-sm text-red-400 hover:text-red-300 transition-colors"
            data-testid="logout-button"
          >
            <LogOut size={20} />
            {sidebarOpen && (
              <span className="text-sm font-medium uppercase tracking-wider">
                Logout
              </span>
            )}
          </button>
        </div>
      </aside>

      <main className="flex-1 overflow-auto">{children}</main>
    </div>
  );
}